import React, { useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import "./OfficerCallOffPenaltiesSection.scss";
import { SettingsCard, RadioWithTooltip } from "../../ui";
import { Tooltip } from "../../../../components";

const OfficerCallOffPenaltiesSection = props => {
	const {
		id,
		sectionRef,
		title,
		subtitle,
		usePenalties,
		handleUsePenaltiesChange,
		lockoutTimeframe,
		handleLockoutTimeframeChange,
		numDaysTimeframe,
		handleNumDayTimeframeChange,
		selectedMonthPenaltyTimeframe,
		selectedDayPenaltyTimeframe,
		handleOnChangeMonthPenaltyTimeframe,
		handleOnChangeDayPenaltyTimeframe,
		callOffPenaltyRules,
		handleOnChangePenaltyRules,
	} = props;
	const { lang } = global;
	const months = [
		{ value: 1, label: "January" },
		{ value: 2, label: "February" },
		{ value: 3, label: "March" },
		{ value: 4, label: "April" },
		{ value: 5, label: "May" },
		{ value: 6, label: "June" },
		{ value: 7, label: "July" },
		{ value: 8, label: "August" },
		{ value: 9, label: "September" },
		{ value: 10, label: "October" },
		{ value: 11, label: "November" },
		{ value: 12, label: "December" },
	];
	const [days, setDays] = useState([]);
	const handleOnChangeMonth = event => {
		const month = event.value;
		const dayList = [...Array(32).keys()];
		dayList.shift();
		if (month === 4 || month === 6 || month === 9 || month === 11) {
			dayList.pop();
		} else if (month === 2) {
			dayList.pop();
			dayList.pop();
		}
		setDays(dayList.map(item => ({ value: item, label: item })));
		handleOnChangeMonthPenaltyTimeframe(month);
	};
	const handleOnChangeDay = event => {
		handleOnChangeDayPenaltyTimeframe(event.value);
	};
	const handleAddRule = () => {
		const newRules = [...callOffPenaltyRules];
		newRules.push({
			callOffs: "",
			suspentionDays: "",
			isValid: true,
			isValidSuspention: true,
		});
		handleOnChangePenaltyRules(newRules);
	};
	const handleDeleteRule = index => {
		let newRules = [...callOffPenaltyRules];
		newRules.splice(index, 1);
		const valueArr = newRules.map(item => item.callOffs);
		const repeats = new Set(valueArr.filter((item, idx) => valueArr.indexOf(item) !== idx));
		newRules = newRules.map(item => ({
			...item,
			isValid: !repeats.has(item.callOffs) && item.callOffs !== 0,
		}));
		handleOnChangePenaltyRules(newRules);
	};
	const handleCallOffsChanged = index => event => {
		const {
			target: { value },
		} = event;
		let newRules = [...callOffPenaltyRules];
		if (Number.isInteger(Number(value))) {
			newRules[index].callOffs = Number(value);
			const valueArr = newRules.map(item => item.callOffs);
			const repeats = new Set(valueArr.filter((item, idx) => valueArr.indexOf(item) !== idx));
			newRules = newRules.map(item => ({
				...item,
				isValid: !repeats.has(item.callOffs) && item.callOffs !== 0,
			}));
			handleOnChangePenaltyRules(newRules);
		} else {
			newRules[index].isValid = false;
		}
	};
	const handleSuspentionDaysChanged = index => event => {
		const {
			target: { value },
		} = event;
		const newRules = [...callOffPenaltyRules];
		if (Number.isInteger(Number(value))) {
			if (Number(value) === 0) {
				newRules[index].isValidSuspention = false;
			} else {
				newRules[index].isValidSuspention = true;
			}
			newRules[index].suspentionDays = Number(value);
			handleOnChangePenaltyRules(newRules);
		} else {
			newRules[index].isValidSuspention = false;
		}
	};
	const handleLockoutDaysChange = event => {
		const {
			target: { value },
		} = event;
		if (Number.isInteger(Number(value))) {
			handleNumDayTimeframeChange(Number(value));
		}
	};
	return (
		<SettingsCard
			id={id}
			sectionRef={sectionRef}
			title={title}
			subtitle={subtitle}
		>
			<div className="col-xs-12 form-group">
				<label htmlFor="UsePenaltiesC">
					<input
						type="checkbox"
						name="UsePenaltiesC"
						id="UsePenaltiesC"
						checked={usePenalties}
						onChange={handleUsePenaltiesChange}
					/>
					{lang.t("Enforce officer penalties")}
				</label>
			</div>
			<If condition={usePenalties}>
				<SettingsCard
					id="cancellation-lockout-section"
					sectionRef={sectionRef}
					title={lang.t("Cancellation lockout_")}
				>
					<div className="standard-padding row">
						<div className="col-xs-12">
							{lang.t(
								"Please select a timeframe for cancellation lockout to be in effect_",
							)}
						</div>
					</div>
					<div className="standard-padding row">
						<RadioWithTooltip
							id="num-days"
							name="num-days"
							handleChange={handleLockoutTimeframeChange(1)}
							checked={lockoutTimeframe === 1}
							label={lang.t("days")}
							tooltipMessage={lang.t(
								"Count call offs within the given number of days_",
							)}
						>
							<div id="days-timeframe-container">
								<input
									id="days-timeframe"
									name="days-timeframe"
									type="tel"
									className={
										Number(numDaysTimeframe) === 0 && lockoutTimeframe === 1
											? "form-control days-timeframe-input invalid-input"
											: "form-control days-timeframe-input"
									}
									value={numDaysTimeframe}
									onChange={handleLockoutDaysChange}
								/>
							</div>
						</RadioWithTooltip>
						<RadioWithTooltip
							id="calendar-month"
							name="calendar-month"
							handleChange={handleLockoutTimeframeChange(2)}
							checked={lockoutTimeframe === 2}
							label={lang.t("Month to date")}
							tooltipMessage={lang.t("Reset call offs every month")}
						/>
						<RadioWithTooltip
							id="calendar-year"
							name="calendar-year"
							handleChange={handleLockoutTimeframeChange(3)}
							checked={lockoutTimeframe === 3}
							label={lang.t("Year to date")}
							tooltipMessage={lang.t("Reset call offs every year")}
						/>
						<If condition={lockoutTimeframe === 4}>
							<div
								className="row"
								style={{ marginLeft: "25px", marginBottom: "20px" }}
							>
								<div className="col-xs-3">
									<span>Select Month</span>
									<Select
										options={months}
										onChange={handleOnChangeMonth}
										defaultValue={selectedMonthPenaltyTimeframe}
									/>
								</div>
								<div className="col-xs-2">
									<span>Select Day</span>
									<Select
										options={days}
										onChange={handleOnChangeDay}
										defaultValue={selectedDayPenaltyTimeframe}
									/>
								</div>
							</div>
						</If>
					</div>
					<div className="standard-padding row">
						<div className="col-xs-5">
							{lang.t("Please customize cancellation lockout rules._")}
						</div>
						<div className="col-xs-1 label-inline-tooltip">
							<Tooltip
								content={lang.t(
									"Suspension will result in the officer being unsassigned from all upcoming jobs in the set time frame",
								)}
							>
								<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
							</Tooltip>
						</div>
						<div className="col-xs-5">
							<button
								type="button"
								className="btn btn-link"
								title={lang.t("New Lockout Rule")}
								onClick={() => handleAddRule()}
							>
								<span className="visible-xs">{`+ ${lang.t("New")}`}</span>
								<span className="hidden-xs">{`+ ${lang.t("New Lockout Rule")}`}</span>
							</button>
						</div>
					</div>
					<For
						each="rule"
						of={callOffPenaltyRules}
						index="index"
					>
						<div
							id="rules-main"
							className="standard-padding row rules-main"
							key={`new-calloff_${index}`}
						>
							<div
								id="rules-container"
								className="col-xs-11 form-group rules-container"
							>
								<p className="rules-text">
									If an officers calls off{" "}
									<span>
										<input
											className={
												rule.isValid
													? "form-control rules-input"
													: "form-control rules-input invalid-input"
											}
											value={rule.callOffs}
											onChange={handleCallOffsChanged(index)}
										/>
									</span>
									times within the selected timeframe, officer will be suspended
									from RollKall for
									<span>
										<input
											className={
												rule.isValidSuspention
													? "form-control rules-input"
													: "form-control rules-input invalid-input"
											}
											value={rule.suspentionDays}
											onChange={handleSuspentionDaysChanged(index)}
										/>
									</span>{" "}
									days.
								</p>
							</div>
							<div className="col-xs-1 text-left delete-button">
								<Tooltip content={lang.t("Delete Rule")}>
									<button
										type="button"
										className="btn btn-link"
										style={{ fontSize: "2rem" }}
										onClick={() => handleDeleteRule(index)}
									>
										<i className="rkf rkf-trash text-danger" />
									</button>
								</Tooltip>
							</div>
						</div>
					</For>
				</SettingsCard>
			</If>
		</SettingsCard>
	);
};

OfficerCallOffPenaltiesSection.propTypes = {
	id: PropTypes.string.isRequired,
	sectionRef: PropTypes.any.isRequired,
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	usePenalties: PropTypes.bool,
	handleUsePenaltiesChange: PropTypes.func.isRequired,
	lockoutTimeframe: PropTypes.number,
	handleLockoutTimeframeChange: PropTypes.func.isRequired,
	selectedMonthPenaltyTimeframe: PropTypes.number,
	selectedDayPenaltyTimeframe: PropTypes.number,
	handleOnChangeMonthPenaltyTimeframe: PropTypes.func.isRequired,
	handleOnChangeDayPenaltyTimeframe: PropTypes.func.isRequired,
	callOffPenaltyRules: PropTypes.array,
	handleOnChangePenaltyRules: PropTypes.func.isRequired,
	numDaysTimeframe: PropTypes.any,
	handleNumDayTimeframeChange: PropTypes.func.isRequired,
};

OfficerCallOffPenaltiesSection.defaultProps = {
	usePenalties: false,
	lockoutTimeframe: 1,
	selectedDayPenaltyTimeframe: null,
	selectedMonthPenaltyTimeframe: null,
	numDaysTimeframe: "",
	callOffPenaltyRules: [
		{
			callOffs: "",
			suspentionDays: "",
			isValid: true,
			isValidSuspention: true,
		},
	],
};

export default OfficerCallOffPenaltiesSection;
